import React from 'react'
import { Link } from 'react-router-dom'

export default function PublicFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid grid-cols-1 gap-8 text-sm sm:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-2">
            <div className="font-semibold text-slate-800">설계EZ</div>
            <div className="text-xs leading-relaxed text-slate-500">
              설계EZ (가라멜 스튜디오) <br />
              대표 가승호 <br />
              사업자등록번호 555-46-01166 <br />
              통신판매업신고번호 2026-부천원미-1316 <br />
              사업장소재지: 경기도 부천시 원미구 수도로 206번길 66-8, 3동 202호 <br />
              전화: 0505-007-8200 <br />
              이메일: support@sgez.co.kr <br />
              호스팅서비스 제공자 Amazon Web Services <br />
              <a
                className="font-semibold text-slate-600 underline hover:text-brand-sky"
                href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=5554601166"
                target="_blank"
                rel="noreferrer"
              >
                사업자정보확인
              </a>
            </div>
            <div className="text-xs text-slate-400">© 2026 설계EZ. All rights reserved.</div>
          </div>

          <div className="space-y-2">
            <div className="font-semibold text-slate-800">서비스</div>
            <div className="flex flex-col gap-2">
              <Link className="text-slate-600 hover:text-brand-sky" to="/landing/sgez">
                설계EZ 소개
              </Link>
            </div>
          </div>

          <div className="space-y-2">
            <div className="font-semibold text-slate-800">문의</div>
            <div className="flex flex-col gap-2">
              <Link className="text-slate-600 hover:text-brand-sky" to="/support/faq">
                FAQ
              </Link>
              <Link className="text-slate-600 hover:text-brand-sky" to="/inquiry">
                도입 문의
              </Link>
              <Link className="text-slate-600 hover:text-brand-sky" to="/support/inquiries">
                고객문의
              </Link>
              <span className="text-xs text-slate-500">전화: 0505-007-8200</span>
              <span className="text-xs text-slate-500">이메일: support@sgez.co.kr</span>
            </div>
          </div>

          <div className="space-y-2">
            <div className="font-semibold text-slate-800">정책</div>
            <div className="flex flex-col gap-2">
              <Link className="text-slate-600 hover:text-brand-sky" to="/terms">
                이용약관
              </Link>
              <Link className="text-slate-600 hover:text-brand-sky" to="/privacy">
                개인정보처리방침
              </Link>
              <Link className="text-slate-600 hover:text-brand-sky" to="/refund-policy">
                환불·취소 정책
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
